<p [ngClass]="classNames()" class="base-text">
  <ng-content></ng-content>
</p>
